import React, { ReactElement } from 'react';
import { Tappable, TappableProps } from 'src/components/Tappable/Tappable';
import useStyles from './SearchBar.styles';
import { useTheme } from '@pulsar/core';

export type SearchBarButtonProps = TappableProps & {
  children: ReactElement;
};

export const SearchBarButton: React.FC<SearchBarButtonProps> = ({ children, style }) => {
  const s = useStyles();
  const { colors } = useTheme();

  return (
    <Tappable style={[s.button, style]}>
      {React.cloneElement(React.Children.only(children), { color: colors.searchBarIcon })}
    </Tappable>
  );
};
